interface TextGroupInputProps {
  disabled?: boolean;
  className?: string;
}

export const TextGroupInput = ({ disabled, className }: TextGroupInputProps) => {
  return (
    <input
      type="text"
      placeholder="Enter text here..."
      disabled={disabled}
      className="border-[#C0275E] bg-transparent border py-1 px-8 rounded-md placeholder:text-sm placeholder:text-[#C0275E]"
    />
  );
};
